import React from 'react';
import { Layout } from 'antd';

import Content from '../../../components/Pages/QcReports/ProfileTemplate';
import { displayName } from '../../../config';

const QcReportTemplateProfile: React.FC = (): JSX.Element => {
  document.title = `${displayName}: QC Report Template Profile`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
};

export default QcReportTemplateProfile;
